const CDN_URL = 'https://d8hicbqy72hcz.cloudfront.net/'

export { CDN_URL }
